import { render, staticRenderFns } from "./PublicProducts.vue?vue&type=template&id=5269dfc7"
import script from "./PublicProducts.vue?vue&type=script&lang=js"
export * from "./PublicProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports